import React, { useState } from "react";
import Button from "../../../Components/Common/Button";
import Input from "../../../Components/Common/Input";
import useSWRMutation from "swr/mutation";
import { AuthUrls } from "../../../Api/Auth/ApiUrls";
import { sendPostRequest } from "../../../Api/swrConfig";
import { toast } from "react-toastify";
import useToastError from "../../../hooks/useErrorToast";
import { Link, useNavigate } from "react-router-dom";

const RegisterForm = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    confirmPassword: "",
    organization: "",
  });
  const [errors, setErrors] = useState({});
  const { showErrorToast } = useToastError();

  // SWR mutation hook to handle the form submission
  const { trigger, isMutating } = useSWRMutation(
    AuthUrls.register,
    sendPostRequest,
    {
      onSuccess: () => {
        toast.success("Success");
        navigate("/login");
      },
      onError: (error) => {
        console.log(error);

        showErrorToast(error);
        // console.log(error);
      },
    }
  );

  const handleInputChange = (name, value) => {
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Simple validation
    const validationErrors = {};
    if (!formData.name) validationErrors.name = "Name is required.";
    if (!formData.email) validationErrors.email = "Email is required.";
    if (!formData.password) validationErrors.password = "Password is required.";
    if (!formData.confirmPassword)
      validationErrors.confirmPassword = "Confirm password is required.";
    else if (formData.confirmPassword !== formData.password)
      validationErrors.confirmPassword = "Passwords do not match.";
    if (!formData.organization)
      validationErrors.organization = "Organization is required.";
    setErrors(validationErrors);
    const modifiedData = { ...formData };
    delete modifiedData.confirmPassword;
    // Handle form submission if there are no errors
    if (Object.keys(validationErrors).length !== 0) {
      return;
    }
    trigger(modifiedData);
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <h2 className="font-regular">Enter your information below to register</h2>

      {/* Name Field */}

      <Input
        label="Name"
        type="text"
        name="name"
        value={formData.name}
        onChange={handleInputChange}
        placeholder="Enter your name"
        error={errors.name}
        required
      />

      {/* Email Field */}

      <Input
        label="Email"
        type="email"
        name="email"
        value={formData.email}
        onChange={handleInputChange}
        placeholder="Enter your email"
        error={errors.email}
        required
      />

      {/* Password Field */}

      <Input
        label="Password"
        type="password"
        name="password"
        value={formData.password}
        onChange={handleInputChange}
        placeholder="Enter your password"
        error={errors.password}
        required
      />

      {/*Reset Password Field */}

      <Input
        label="Confirm Password"
        type="password"
        name="confirmPassword"
        value={formData.confirmPassword}
        onChange={handleInputChange}
        placeholder="Confirm your password"
        error={errors.confirmPassword}
        required
      />

      {/* Organization Field */}

      <Input
        label="Organization/University/Institute/Others"
        type="text"
        name="organization"
        value={formData.organization}
        onChange={handleInputChange}
        placeholder="Enter your organization"
        error={errors.organization}
        required
      />

      {/* Submit Button */}
      <div className="flex items-center gap-4">
        <Button type="primary" isLoading={isMutating}>
          Register
        </Button>
        <Link to="/login">
          <p className="text-sm underline">Already Registered?</p>
        </Link>
      </div>
    </form>
  );
};

export default RegisterForm;
